import script from "./IndicatorsStatisticTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndicatorsStatisticTable.vue?vue&type=script&setup=true&lang=ts"

import "./IndicatorsStatisticTable.vue?vue&type=style&index=0&id=c2ae4c90&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ae4c90"]])

export default __exports__